import { useEffect, useState } from "react";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import PressRelease from "@/components/PressRelease";
import NewsletterSignup from "@/components/NewsletterSignup";
import img from "../../public/lovable-uploads/0b3c3dab-7f08-4fa2-9306-06615336a55a.png";
import { fetchPageContent } from "@/api/apis";
import HTML_Renderer from "@/components/HTML_Renderer";

export default function PrivacyPolicies() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchPageContent("privacy").then((res) => {
      const sections = ["head"];
      const sectionsData: any = {};

      Object.keys(res.data.content).map((fieldKey) => {
        const fieldSection = sections.find((sec) => fieldKey.includes(sec));

        if (fieldSection) {
          sectionsData[fieldSection] = {
            ...(sectionsData[fieldSection] || {}),
            [fieldKey.replace(fieldSection + "_", "")]:
              res.data.content[fieldKey],
          };
        }
      });

      setContent(sectionsData);
    });
  }, []);
  return (
    <div className="min-h-screen bg-musicBlack">
      <Header />
      {content?.head && (
        <>
          <section className=" relative overflow-hidden pt-24 pb-12">
            {/* Noise texture */}
            <div className="noise-overlay"></div>

            {/* Light blob effects */}
            <div className="light-blob light-blob--1"></div>
            <div className="light-blob light-blob--2"></div>

            <div className="editorial-container">
              <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-white font-serif text-4xl md:text-6xl font-bold mb-6 animate-slide-in-top">
                  {content.head.title}
                </h1>
              </div>
            </div>
          </section>
          <section className="section-dark py-8 mb-16">
            <div className="editorial-container">
              <div className="max-w-4xl mx-auto">
                <HTML_Renderer
                  content={content.head.content}
                  className={"mb-12"}
                />
              </div>
            </div>
          </section>
        </>
      )}
      <NewsletterSignup />
      <Footer />
    </div>
  );
}
